export default "__VITE_ASSET__BGpWWmhQ__"